import { NeoModel, ModelBase } from '@singularsystems/neo-core';
import InstrumentMappingsLookup from './InstrumentMappingLookupModel';
import InstrumentSearchLookup from './InstrumentSearchLookup';


@NeoModel
export default class InstrumentMappingUpdate extends ModelBase {
    public selectedInstrument = new InstrumentSearchLookup();

    public mappings: InstrumentMappingsLookup[] = [];
}